module.exports = __webpack_public_path__ + "static/media/stepOne.fd03ca16.jpg";